import app from 'flarum/common/app';
app.initializers.add('redundans-calendar-event-common', () => {
  console.log('[redundans/calendar-event] Hello, forum and admin!');
});